import React, { useState, useEffect } from "react";
import axios from 'axios';
import { BASEURL } from "../Config";
import Footer from "../components/Footer";
import { NavLink, useHistory } from 'react-router-dom';
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { useSelector } from "react-redux";
import { getClassInfo, getElpChapterInfo } from "../modules/reducers";
import MyDropzone from "../components/MyDropzone";
import VideoCard from "./VideoCard";
import swal from 'sweetalert';


const AddElpQuestions = (props) => {
    const history = useHistory();
    const qtype = history.location.state && history.location.state.ctype
    const createGrammarBlankOptions = () => ([
        { answer: "", is_correct: false },
        { answer: "", is_correct: false },
        { answer: "", is_correct: false },
        { answer: "", is_correct: false }
    ]);

    const getBlankCount = (text) => (text?.match(/<<blank>>/gi) || []).length;

    const getGrammarCorrectAnswers = (grammarOptions = []) =>
        grammarOptions.map((blank) =>
            blank.options?.find((option) => option.is_correct)?.answer || ""
        );
    const [data, setData] = useState([{
        qtype: "mcq",
        qtitle: "",
        meaning: "",
        includeVideo: false,
        videoUrl: "",
        display_question: false,
        options: [{
            answer: "",
            is_correct: false
        }],
        grammar_options: [{
            blank_index: 0,
            options: createGrammarBlankOptions()
        }],
        subQuestions: [{
            question: "",
            answer: "",
            question_file_url: "",
            answer_file_url: "",
            question1_urlError: false,
            question2_urlError: false,
            options: qtype === 'reading' || qtype === 'learning' ?[{
                answer: "",
                is_correct: false
            }] : [],
        }],
        sentences: [],
        questionError: false,
        optionsError: false,
        sub_questionsError: false,
        subQuestionsErrorMessages: "",
        optionsErrorMessages: "",
        isCollapsed: false,
    }]);

    const class_data = useSelector(getClassInfo);
    const chapter = useSelector(getElpChapterInfo);
    const [isChecked, setIsChecked] = useState(false);

    const handleToggle = (idx) => {
        setIsChecked(!isChecked);
        let newData = [...data];
        newData[idx].display_question = isChecked;
        setData(newData);
    };

    useEffect(() => {
        console.log('class', class_data);
        console.log('chapter', chapter);
        console.log('qtype', qtype);
    }, [class_data, chapter]);


    const handleOnClickCollapseOpenBtn = (e, idx) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].isCollapsed = false;
        setData(newData);
    };

    const handleOnClickCollapseCloseBtn = (e, idx) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].isCollapsed = true;
        setData(newData);
    };

    const handleOnAddQuestion = (e, qtype) => {
        e.preventDefault();
        if (validateQObject()) {
            setData([...data, {
                qtype: "mcq",
                qtitle: "",
                meaning: "",
                includeVideo: false,
                videoUrl: "",
                display_question: true,
                options: [{
                    answer: "",
                    is_correct: false
                }],
                grammar_options: [{
                    blank_index: 0,
                    options: createGrammarBlankOptions()
                }],
                subQuestions: [{
                    question: "",
                    answer: "",
                    question_file_url: "",
                    answer_file_url: "",
                    question1_urlError: false,
                    question2_urlError: false,
                    options: qtype === 'reading' || qtype === 'learning' ?[{
                        answer: "",
                        is_correct: false
                    }] : [],
                }],
                sentences: [],
                questionError: false,
                optionsError: false,
                sub_questionsError: false,
                subQuestionsErrorMessages: "",
                optionsErrorMessages: "",
                isCollapsed: false,
            }]);
        }
    };

    const handleToggleVideo = (idx) => {
        let newData = [...data];
        newData[idx].includeVideo = !newData[idx].includeVideo;
        if (!newData[idx].includeVideo) {
            newData[idx].videoUrl = "";
            newData[idx].metaData = null;
        }
        newData[idx].sub_questionsError = false;
        setData(newData);
    };

    const handleOnDeleteQuestion = (e, idx) => {
        e.preventDefault();
        let newData = [...data];
        newData.splice(idx, 1);
        setData(newData);
    };

    const handleChange = (e, idx) => {
        let newData = [...data];
        newData[idx][e.target.name] = e.target.value;
        if(qtype === 'learning' && e.target.name === 'videoUrl') {
            newData[idx].metaData = null; // Reset video details when URL changes
        }
        setData(newData);
    };

    // const handleOnChangeOptions = (field, value, idx, idx1) => {
    //     let newData = [...data];
    //     let options = newData[idx].options;
    //     if (data[idx].optionsError) {
    //         setData([...data[idx].optionsError])
    //     }
    //     if (field === "answer") {
    //         options[idx1][field] = value;
    //     } else if (field === "grammar") {
    //         options[idx1]["answer"] = value;
    //         options[idx1]["is_correct"] = true;
    //     } else if (field === "sentences") {
    //         if (!newData[idx].sentences) {
    //             newData[idx].sentences = [];
    //         }
    //         newData[idx].sentences[idx1] = value;
    //     } else if (field === "meaining") {
    //         newData[idx].meaning = value
    //     } else {
    //         for (let i = 0; i < newData[idx].options.length; i++) {
    //             newData[idx].options[i].is_correct = false;
    //         }
    //         options[idx1][field] = value;
    //     }

    //     setData(newData);
    // };

    const handleOnChangeOptions = (field, value, questionIndex, optionIndex) => {
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const options = currentQuestion.options || [];

        if (field === "answer") {
            options[optionIndex][field] = value;
        } else if (field === "grammar") {
            options[optionIndex]["answer"] = value;
            options[optionIndex]["is_correct"] = true;
        } else if (field === "sentences") {
            currentQuestion.sentences = currentQuestion.sentences || [];
            currentQuestion.sentences[optionIndex] = value;
        } else if (field === "meaning") {
            currentQuestion.meaning = value;
        } else if( field === "metaData") {
            currentQuestion.metaData = value;
            currentQuestion.questionError = false; // Clear question error if video details are fetched
        }
        else {
            options.forEach((option, idx) => {
                option.is_correct = idx === optionIndex;
            });
        }

        // Clear optionsError if the error is resolved (e.g., after selecting a correct option)
        if (currentQuestion.optionsError) {
            currentQuestion.optionsError = false;
            currentQuestion.optionsErrorMessages = []; // Clear error messages
        }
        // Update the state with the modified data
        setData(updatedData);
    };

    const handleOnChangeGrammarOption = (questionIndex, blankIndex, optionIndex, value) => {
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const blanks = currentQuestion.grammar_options || [];
        if (!blanks[blankIndex]) return;
        blanks[blankIndex].options[optionIndex].answer = value;
        currentQuestion.grammar_options = blanks;
        setData(updatedData);
    };

    const handleSelectGrammarCorrect = (questionIndex, blankIndex, optionIndex) => {
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const blanks = currentQuestion.grammar_options || [];
        if (!blanks[blankIndex]) return;
        blanks[blankIndex].options = blanks[blankIndex].options.map((opt, idx) => ({
            ...opt,
            is_correct: idx === optionIndex
        }));
        currentQuestion.grammar_options = blanks;
        setData(updatedData);
    };

    const handleOnAddGrammarBlank = (e, questionIndex) => {
        e.preventDefault();
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const blanks = currentQuestion.grammar_options || [];
        blanks.push({
            blank_index: blanks.length,
            options: createGrammarBlankOptions()
        });
        currentQuestion.grammar_options = blanks;
        setData(updatedData);
    };

    const handleOnDeleteGrammarBlank = (e, questionIndex, blankIndex) => {
        e.preventDefault();
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const blanks = currentQuestion.grammar_options || [];
        blanks.splice(blankIndex, 1);
        currentQuestion.grammar_options = blanks.map((blank, idx) => ({
            ...blank,
            blank_index: idx
        }));
        setData(updatedData);
    };

    const handleOnChangeOptionsForSubQuestions = (field, value, questionIndex, subQuestionIdx, optionIndex) => {
        const updatedData = [...data];
        const currentQuestion = updatedData[questionIndex];
        const currentSubQuestion = currentQuestion.subQuestions[subQuestionIdx];
        const options = currentSubQuestion.options || [];

        if (field === "answer") {
            options[optionIndex][field] = value;
        } else {
            options.forEach((option, idx) => {
                option.is_correct = idx === optionIndex;
            });
        }

        // Clear optionsError if the error is resolved (e.g., after selecting a correct option)
        if (currentQuestion.optionsError) {
            currentQuestion.optionsError = false;
            currentQuestion.optionsErrorMessages = []; // Clear error messages
        }
        // Update the state with the modified data
        setData(updatedData);
    };

    const handleOnAddOptionsForSubQuestions = (e, questionIdx, subQuestionIdx) => {
        e.preventDefault();
        let newData = [...data];
        console.log('newData', newData)
        newData[questionIdx].subQuestions[subQuestionIdx].options.push({
            answer: "",
            is_correct: false
        });
        setData(newData);
    };

    const handleOnDeleteOptionsForSubQuestions = (e, idx, idx1, optionIdx) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].subQuestions[idx1].options.splice(optionIdx, 1);
        setData(newData);
    };
    const handleOnAddOptions = (e, idx) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].options.push({
            answer: "",
            is_correct: false
        });
        setData(newData);
    };

    const handleOnDeleteOptions = (e, idx, idx1) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].options.splice(idx1, 1);
        setData(newData);
    };


    const handleOnChangesubQuestions = (field, value, idx, idx1) => {
        let newData = [...data];
        newData[idx].subQuestions[idx1][field] = value;
        console.log('subQuestions', newData[idx].subQuestions[idx1])
        setData(newData);
    };

    const handleFileUpload = (file, idx, idx1, field) => {
        let newData = [...data];
        newData[idx].subQuestions[idx1][field] = file;
        console.log('newData', newData)
        setData(newData);
    };

    const handleOnDeletesubQuestions = (e, idx, idx1) => {
        e.preventDefault();
        let newData = [...data];
        newData[idx].subQuestions.splice(idx1, 1);
        setData(newData);
    };

    const handleOnAddSubQuestions = (e, idx, qtype) => {
        e.preventDefault();
        // console.log('validateQObject()', validateQObject())
        const isValid = validateQObject();
        console.log('isValid', isValid)
        if (isValid) {

            let newData = [...data];
            newData[idx].subQuestions.push({
                question: "",
                answer: "",
                question_file_url: "",
                answer_file_url: "",
                question1_urlError: false,
                question2_urlError: false,
                options: qtype === 'reading' || qtype === 'learning' ?[{
                    answer: "",
                    is_correct: false
                }] : [],
            });
            setData(newData);
        }
    };
    const validateQObject = () => {
        const validationResult = data.map(item => {
            // Validate options
            const optionsErrorMessages = [];
            const isLearning = qtype === "learning";

            if (!["vocabulary", "speaking", "reading"].includes(qtype) && !isLearning) {
                if (qtype !== "grammar" && (!Array.isArray(item.options) || item.options.length < 2)) {
                    optionsErrorMessages.push('At least 2 options are required.');
                }
                if (qtype === "grammar") {
                    const blankCount = getBlankCount(item.qtitle);
                    if (!Array.isArray(item.grammar_options) || item.grammar_options.length === 0) {
                        optionsErrorMessages.push('At least one blank with 4 options is required.');
                    } else {
                        if (blankCount > 0 && item.grammar_options.length !== blankCount) {
                            optionsErrorMessages.push('Number of blanks must match the number of blank option sets.');
                        }
                        const hasInvalidBlank = item.grammar_options.some(blank =>
                            !Array.isArray(blank.options) ||
                            blank.options.length !== 4 ||
                            blank.options.some(opt => !opt.answer || opt.answer.trim() === "") ||
                            !blank.options.some(opt => opt.is_correct)
                        );
                        if (hasInvalidBlank) {
                            optionsErrorMessages.push('Each blank must have 4 options and one correct answer.');
                        }
                    }
                }
                if (qtype !== "grammar") {
                    if (item.options.some(option => option.answer.trim() === "")) {
                        optionsErrorMessages.push('All options must have a non-empty answer.');
                    }
                }

                if (qtype !== "grammar" && !item.options.some(option => option.is_correct)) {
                    optionsErrorMessages.push('At least one option must be marked as correct.');
                }
            }
            // Learning: always validate word fields (meaning + sentences)
            if (isLearning) {
                if (!item.meaning || item.meaning.trim() === "") {
                    optionsErrorMessages.push('Meaning is required.');
                }
                if (!Array.isArray(item.sentences) || item.sentences.length === 0 || item.sentences.some(s => !s || s.trim() === "")) {
                    optionsErrorMessages.push('At least one sentence is required with non-empty values.');
                }
            }
            const optionsError = optionsErrorMessages.length > 0;

            // Validate subQuestions
            const subQuestionsErrorMessages = [];
            if (qtype === "vocabulary") {
                if (!Array.isArray(item.subQuestions) || item.subQuestions.length === 0 || item.subQuestions.some(sub => !sub.question || !sub.answer)) {
                    subQuestionsErrorMessages.push('Sub-questions are required and must have non-empty question and answer.');
                }
                if (!Array.isArray(item.subQuestions) || item.subQuestions.length === 0 || item.subQuestions.some(sub => !sub.question1_urlError)) {
                    subQuestionsErrorMessages.push('Thumblink  are required and must have non-empty question and answer.');
                }

            }
            if (qtype === "reading") {
                if (!Array.isArray(item.subQuestions) || item.subQuestions.length === 0 || item.subQuestions.some(sub => !sub.question)) {
                    subQuestionsErrorMessages.push('Sub-questions are required and must have non-empty question.');
                }
                else if(item.subQuestions.some(sub => sub.options.length < 2)) {
                    subQuestionsErrorMessages.push('At least 2 options are required for each sub-question.');
                }
                else if (item.subQuestions.some(sub => sub.options.some(option => option.answer.trim() === ""))) {
                    subQuestionsErrorMessages.push('All options must have a non-empty answer for each sub-question.');
                }
                else if (!item.subQuestions.some(sub => sub.options.some(option => option.is_correct))) {
                    subQuestionsErrorMessages.push('One option must be marked as correct for each sub-question.');
                }
            }
            // Learning with video: validate sub-questions only when video is included
            if (isLearning && item.includeVideo) {
                if (!item.videoUrl || item.videoUrl.trim() === "") {
                    subQuestionsErrorMessages.push('YouTube URL is required when video is included.');
                }
                if (!Array.isArray(item.subQuestions) || item.subQuestions.length === 0 || item.subQuestions.some(sub => !sub.question)) {
                    subQuestionsErrorMessages.push('Sub-questions are required and must have non-empty question.');
                }
                else if(item.subQuestions.some(sub => sub.options.length < 2)) {
                    subQuestionsErrorMessages.push('At least 2 options are required for each sub-question.');
                }
                else if (item.subQuestions.some(sub => sub.options.some(option => option.answer.trim() === ""))) {
                    subQuestionsErrorMessages.push('All options must have a non-empty answer for each sub-question.');
                }
                else if (!item.subQuestions.some(sub => sub.options.some(option => option.is_correct))) {
                    subQuestionsErrorMessages.push('One option must be marked as correct for each sub-question.');
                }
            }
            const sub_questionsError = subQuestionsErrorMessages.length > 0;

            const question_req = item.qtitle.trim() === "";
            console.log('question_req', question_req, sub_questionsError, optionsError)

            return {
                ...item, // Spread existing item properties
                questionError: question_req,
                optionsError: optionsError,
                optionsErrorMessages: optionsErrorMessages,
                sub_questionsError: sub_questionsError,
                subQuestionsErrorMessages: subQuestionsErrorMessages,
            };
        });

        // console.log('validationResult', validationRes/ult);

        // Determine if there are any validation errors
        const hasErrors = validationResult.some(item =>
            item.questionError ||
            item.optionsError ||
            item.sub_questionsError
        );
        console.log('validationResult', validationResult)
        // Update data state with validation results
        setData(validationResult);

        return !hasErrors; // Return false if there are errors, true otherwise
    };




    const handleSubmit = async () => {
        console.log('data', data);
        console.log('class_data.uuid', class_data)
        const isValid = validateQObject();
        if (isValid) {


            let questionsData = await Promise.all(data.map(async (item) => {
                let qObject = {
                    class_uuid: class_data.uuid,
                    chapter_uuid: chapter.uuid,
                    category: qtype,
                    question: item.qtitle,
                    options: [],
                    sub_questions: [],
                    sentences: []
                };
                if (qtype === "listening") {
                    qObject.display_question = item.display_question;
                }
                if (qtype === 'reading' || (qtype === 'learning' && item.includeVideo) || qtype === "vocabulary") {
                    qObject.sub_questions = item.subQuestions;
                }
                if( qtype === 'grammar') {
                    const grammarAnswers = getGrammarCorrectAnswers(item.grammar_options || []);
                    qObject.answer = generateQuestion(item.qtitle, grammarAnswers)
                    qObject.grammar_options = item.grammar_options || [];
                }
                if (qtype === "listening" || qtype === "reading") {
                    qObject.options = item.options;
                }
                // Learning: always include word data
                if (qtype === "learning") {
                    qObject.options = [{
                        answer: item.meaning,
                        is_correct: true
                    }];
                    qObject.sentences = item.sentences;
                    // Optionally include video data
                    if (item.includeVideo && item.videoUrl) {
                        qObject.video_url = item.videoUrl;
                        qObject.metaData = await getVideoDetails(item);
                    }
                }
                return qObject;
            }));


            console.log('questions data', questionsData);
            axios.post(`${BASEURL}/api/v1/elp/questions/save-all`, questionsData)
                .then(res => {
                    if (res.status === 200) {
                        //console.log('res.data', res.data);
                        window.location = 'elpQuestions';
                    }
                })
                .catch((err) => {
                    console.log('Create Questions Error', err);
                });
        }
    };

    const getVideoDetails = async (question) => {
        const metaData = question.metaData;
        if (metaData) return metaData;

        try {
            const res = await fetch(`${BASEURL}/api/v1/elp/youtube-video-details/fetch?url=${encodeURIComponent(question.videoUrl)}`);
            const data = await res.json();

            if (data.error) throw new Error(data.error);

            return data;
        } catch (err) {
            console.error("Error fetching video details:", err);
        }
    };

        const generateQuestion = (questionTemplate, answers) => {
                let index = 0;
                return questionTemplate?.replace(/<<blank>>/g, () => {
                    return answers?.[index]?.length > 0 ? answers?.[index++] : '_____';
                });
        }

    const handleFetchVideoDetails = async (idx) => {
        const url = data[idx].videoUrl;
        if (!url || url.trim() === "") {
            swal("Error", "Please enter a YouTube URL first.", "error");
            return;
        }
        try {
            const res = await fetch(`${BASEURL}/api/v1/elp/youtube-video-details/fetch?url=${encodeURIComponent(url)}`);
            const result = await res.json();

            if (result.error) throw new Error(result.error);

            handleOnChangeOptions("metaData", result, idx);
        } catch (err) {
            swal("Error", "Failed to fetch video details: " + err.message, "error");
        }
    };

    return (
        <div id="wrapper">
            <Sidebar act="classes" />
            {/* Content Wrapper */}
            <div className="content-page">
                {/* Main Content */}
                <div className="content">
                    <Topbar act={`Add Questions for ${qtype}`} breadcrumbItems={[
                        { label: "ELP", path: "/elp" },
                        { label: "Classes", path: "/classes" },
                        { label: "Chapter", path: "/elpChapters" },
                        { label: "Add Questions" }
                    ]} />
                    {/* container */}
                    {/* content */}
                    <div className="container-fluid main-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="card main-card">
                                    <div className="card-body questions-card-body">
                                        {data.map((item, idx) => (
                                            <div className="questionsDiv">
                                                {item.isCollapsed ?
                                                    <>
                                                        <div className="d-flex">
                                                            <span className="question-no">{qtype === "reading" ? 'Paragraph' + (idx + 1) : 'Question' + (idx + 1)}</span>
                                                            <div className="collapse-btn-div">
                                                                <button className="btn" onClick={(e) => handleOnClickCollapseOpenBtn(e, idx)}>
                                                                    <i className="uil-angle-down"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p className="questionText overflow-auto max-height-50">{item.qtitle ? item.qtitle : 'Untitled Question'}</p>
                                                            {qtype === "listening" && <p className="questionType">Multiple Choice Question</p>}
                                                            {qtype === "reading" && <p className="questionType">Paragraph Question</p>}
                                                            {qtype === "grammar" && <p className="questionType">Fill in the Blanks</p>}
                                                            {qtype === "learning" && <p className="questionType">Learning</p>}
                                                            {qtype === "vocabulary" && <p className="questionType">Match the Following</p>}

                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="row">
                                                            <div className="d-flex">
                                                            <span className="question-no">{qtype === "reading" ? 'Paragraph ' + (idx + 1) : qtype === "learning" ? (idx + 1) + '. Learning Content' : 'Question ' + (idx + 1)}</span>
                                                                <div className="collapse-btn-div">
                                                                    <button className="btn" onClick={(e) => handleOnClickCollapseCloseBtn(e, idx)}><i className="uil-angle-up"></i></button>
                                                                </div>
                                                            </div>
                                                            {qtype === "listening" && (
                                                                <div className="d-flex gap-2">
                                                                    <p>Use this toggle to show or hide the question for students.</p>

                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="flexSwitchCheckDefault"
                                                                            checked={item.display_question}
                                                                            onChange={() => handleToggle(idx)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                                                                            {item.display_question ? "Showing Question" : 'Hiding Question'}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {qtype === "grammar" && (<p className="question-no">{`Please insert <<blank>> in place of the blank space.`}</p>)}
                                                            {qtype === "learning" && (
                                                                <div className="d-flex gap-2 mt-2 align-items-center">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`includeVideo-${idx}`}
                                                                            checked={item.includeVideo || false}
                                                                            onChange={() => handleToggleVideo(idx)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`includeVideo-${idx}`}>
                                                                            Include Video Learning (Optional)
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xl-12">
                                                                <div className="mb-3">
                                                                    {/* Learning: always show word input */}
                                                                    {qtype === "learning" && (
                                                                        <>
                                                                            <textarea
                                                                                className="form-control"
                                                                                rows="1"
                                                                                name="qtitle"
                                                                                placeholder="Enter the Word"
                                                                                value={item.qtitle}
                                                                                onChange={(e) => handleChange(e, idx)}>
                                                                            </textarea>
                                                                            {item.questionError && (
                                                                                <p className="text-danger">
                                                                                    *Word is required field.
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {/* Non-learning types */}
                                                                    {qtype !== "learning" && (
                                                                        <>
                                                                            <div className="input-group w-100">
                                                                                <textarea
                                                                                    class="form-control"
                                                                                    rows={qtype === "reading" ? "10" : "2"}
                                                                                    name="qtitle"
                                                                                    placeholder={qtype === "reading" ? "Enter Paragraph" : "Enter your Question"}
                                                                                    value={item.qtitle}
                                                                                    onChange={(e) => handleChange(e, idx)}>
                                                                                </textarea>
                                                                            </div>
                                                                            {item.questionError && (
                                                                                <p className="text-danger">
                                                                                    *Question is required field.
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {qtype === "listening" &&(
                                                            <>
                                                                <div className="answer_header">
                                                                    <p className="answers_title">Answers</p>
                                                                    <p>Select Correct Answer</p>
                                                                </div>
                                                                {item.options.map((item1, idx1) => (
                                                                    <div className="form-group col-md-12 mb-2">
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control"
                                                                                placeholder="Enter Answer"
                                                                                defaultValue={item1.answer}
                                                                                onChange={(e) =>
                                                                                    handleOnChangeOptions(
                                                                                        "answer",
                                                                                        e.target.value,
                                                                                        idx,
                                                                                        idx1
                                                                                    )
                                                                                }
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <div className="input-group-text answerRadioBtn">
                                                                                    <div className="custom-control custom-radio">
                                                                                        <input type="radio"
                                                                                            name={`is_correct${idx}`}
                                                                                            className="custom-control-input"
                                                                                            defaultChecked={item1.is_correct}
                                                                                            onChange={(e) =>
                                                                                                handleOnChangeOptions(
                                                                                                    "is_correct",
                                                                                                    true,
                                                                                                    idx,
                                                                                                    idx1
                                                                                                )
                                                                                            } />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <button
                                                                                className="btn deleteAnswerBtn"
                                                                                onClick={(e) =>
                                                                                    handleOnDeleteOptions(e, idx, idx1)
                                                                                }
                                                                            >
                                                                                <i class="uil-times"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.optionsError && (
                                                                    <p className="text-danger">
                                                                        {item.optionsErrorMessages[0]}
                                                                    </p>
                                                                )}
                                                                <button type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => handleOnAddOptions(e, idx)}>
                                                                    <i className="mdi mdi-plus-circle"></i> Add Options</button>
                                                            </>
                                                        )}
                                                        {qtype === "reading" && (
                                                            <>
                                                                <div className="answer_header">
                                                                    <p className="question-no">Questions</p>
                                                                    <p></p>
                                                                </div>
                                                                {item?.subQuestions?.map((subQuestion, idx1) => (
                                                                    <div className="form-group col-md-12" key={idx1}>
                                                                        <p className="answers_title">Question {idx1+1}</p>
                                                                        <div className="input-group">
                                                                            <div className="d-flex align-items-center col-md-12 mb-2">
                                                                                <div className="col-md-10 col-sm-5">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control subq"
                                                                                        placeholder="Enter Question"
                                                                                        value={subQuestion.question}
                                                                                        onChange={(e) => handleOnChangesubQuestions("question", e.target.value, idx, idx1)}
                                                                                    />
                                                                                </div>
                                                                                <button type="button"
                                                                                    className="btn btn-customprimary ms-2"
                                                                                    style={{ opacity: "50%" }}
                                                                                    onClick={(e) => handleOnAddOptionsForSubQuestions(e, idx, idx1)}>
                                                                                    <i className="mdi mdi-plus-circle"></i> Add Options
                                                                                </button>
                                                                                <button
                                                                                    disabled={item.subQuestions.length === 1}
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) => handleOnDeletesubQuestions(e, idx, idx1)}>
                                                                                    <i className="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                            <p className="answers_title">Options</p>
                                                                            {subQuestion.options?.map((option, idx2) => (
                                                                                <div className="col-12">
                                                                                    <div className="row mb-2">
                                                                                        <div className="col-6">
                                                                                            <div className="input-group">
                                                                                                <input 
                                                                                                    type="text"
                                                                                                    name={`answer_${idx}${idx1}${idx2}`}
                                                                                                    className="form-control"
                                                                                                    placeholder="Enter Option"
                                                                                                    value={option.answer}
                                                                                                    onChange={(e) =>
                                                                                                        handleOnChangeOptionsForSubQuestions(
                                                                                                            "answer",
                                                                                                            e.target.value,
                                                                                                            idx,
                                                                                                            idx1,
                                                                                                            idx2
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                                <div className="input-group-append">
                                                                                                    <div className="input-group-text answerRadioBtn">
                                                                                                        <div className="custom-control custom-radio">
                                                                                                            <input type="radio"
                                                                                                                name={`is_correct${idx}${idx1}${idx2}`}
                                                                                                                className="custom-control-input"
                                                                                                                // defaultChecked={option.is_correct}
                                                                                                                checked={option.is_correct}
                                                                                                                onChange={(e) =>
                                                                                                                    handleOnChangeOptionsForSubQuestions(
                                                                                                                        "is_correct",
                                                                                                                        true,
                                                                                                                        idx,
                                                                                                                        idx1,
                                                                                                                        idx2
                                                                                                                    )
                                                                                                                } />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <button
                                                                                                    className="btn deleteAnswerBtn"
                                                                                                    onClick={(e) =>
                                                                                                        handleOnDeleteOptionsForSubQuestions(e, idx, idx1, idx2 )
                                                                                                    }
                                                                                                >
                                                                                                    <i class="uil-times"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                            {subQuestion.optionsError && (
                                                                                <p className="text-danger">
                                                                                    {item.optionsErrorMessages[0]}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.sub_questionsError && (
                                                                    <p className="text-danger">
                                                                        {item.subQuestionsErrorMessages[0]}
                                                                    </p>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => handleOnAddSubQuestions(e, idx, qtype)}
                                                                >
                                                                    <i className="mdi mdi-plus-circle"></i> Add Questions
                                                                </button>
                                                            </>
                                                        )}
                                                        {qtype === "grammar" && (
                                                            <>
                                                                <div className='d-flex gap-2 mb-2'>
                                                                    <b>Ans:</b><div className='font-italics'>`{generateQuestion(item.qtitle, getGrammarCorrectAnswers(item.grammar_options || []))}`</div>
                                                                </div>
                                                                {(item.grammar_options || []).map((blank, blankIndex) => (
                                                                    <div className="form-group col-md-12 mb-3" key={`blank-${blankIndex}`}>
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <p className="mb-0 mr-2">Blank {blankIndex + 1}</p>
                                                                            <button
                                                                                className="btn deleteAnswerBtn"
                                                                                onClick={(e) => handleOnDeleteGrammarBlank(e, idx, blankIndex)}
                                                                            >
                                                                                <i className="uil-times"></i>
                                                                            </button>
                                                                        </div>
                                                                        <div className="row">
                                                                            {(blank.options || []).map((opt, optIdx) => (
                                                                                <div className="col-md-6 mb-2" key={`blank-${blankIndex}-opt-${optIdx}`}>
                                                                                    <div className="input-group">
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            placeholder={`Option ${optIdx + 1}`}
                                                                                            value={opt.answer}
                                                                                            onChange={(e) => handleOnChangeGrammarOption(idx, blankIndex, optIdx, e.target.value)}
                                                                                        />
                                                                                        <div className="input-group-append">
                                                                                            <div className="input-group-text answerRadioBtn">
                                                                                                <div className="custom-control custom-radio">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        name={`grammar_correct_${idx}_${blankIndex}`}
                                                                                                        className="custom-control-input"
                                                                                                        checked={opt.is_correct}
                                                                                                        onChange={() => handleSelectGrammarCorrect(idx, blankIndex, optIdx)}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.optionsError && (
                                                                    <p className="text-danger">
                                                                        {item.optionsErrorMessages[0]}
                                                                    </p>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => handleOnAddGrammarBlank(e, idx)}
                                                                >
                                                                    <i className="mdi mdi-plus-circle"></i> Add Blank
                                                                </button>
                                                            </>
                                                        )}
                                                        {qtype === "vocabulary" && (
                                                            <>
                                                                <div className="answer_header">
                                                                    <p className="answers_title">Questions</p>
                                                                    <p className="answers_title1">Answers</p>
                                                                </div>
                                                                {item.subQuestions.map((item1, idx1) => (
                                                                    <div className="form-group col-md-12" key={idx1}>
                                                                        <div className="input-group subQuestionsGroup">
                                                                            <div className="col-md-5 col-sm-5">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control subq"
                                                                                    placeholder="Enter Question"
                                                                                    value={item1.question}
                                                                                    onChange={(e) => handleOnChangesubQuestions("question", e.target.value, idx, idx1)}
                                                                                />
                                                                            </div>
                                                                            <div className="delimiter"></div>
                                                                            <div className="col-md-5 col-sm-5">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control suba"
                                                                                    placeholder="Enter Answer"
                                                                                    value={item1.answer}
                                                                                    onChange={(e) => handleOnChangesubQuestions("answer", e.target.value, idx, idx1)}
                                                                                />
                                                                            </div>
                                                                            <button
                                                                                className="btn deleteAnswerBtn"
                                                                                onClick={(e) => handleOnDeletesubQuestions(e, idx, idx1)}
                                                                            >
                                                                                <i className="uil-times"></i>
                                                                            </button>
                                                                        </div>
                                                                        <div className="d-flex gap-3">
                                                                            <div className="col-md-5 col-sm-5">
                                                                                <div className="mb-3">
                                                                                    <label className="mb-1">Question Image</label>
                                                                                    <MyDropzone
                                                                                        file={item1.question_file_url}
                                                                                        setFile={(file) => handleFileUpload(file, idx, idx1, "question_file_url")}
                                                                                        setError={(error) => handleOnChangesubQuestions("question1_urlError", true, idx, idx1)}
                                                                                        fromPage="editBookPage"
                                                                                    />
                                                                                    {/* {item1.question1_urlError && <p className="errTxt">Thumbnail is Required</p>} */}
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className="col-md-5 col-sm-5">
                                                                                <div className="mb-3">
                                                                                    <label className="mb-1">Answer Image</label>
                                                                                    <MyDropzone
                                                                                        file={item1.answer_file_url}
                                                                                        setFile={(file) => handleFileUpload(file, idx, idx1, "answer_file_url")}
                                                                                        setError={(error) => handleOnChangesubQuestions("question2_urlError", error, idx, idx1)}
                                                                                        fromPage="editBookPage"
                                                                                    />
                                                                                    {item1.question2_urlError && <p className="errTxt">Thumbnail is Required</p>}
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.sub_questionsError && (
                                                                    <p className="text-danger">
                                                                        {item.subQuestionsErrorMessages[0]}
                                                                    </p>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => handleOnAddSubQuestions(e, idx, qtype)}
                                                                >
                                                                    <i className="mdi mdi-plus-circle"></i> Add Questions
                                                                </button>
                                                            </>

                                                        )}
                                                        {/* Learning: Meaning + Sentences (always shown) */}
                                                        {qtype === "learning" && (
                                                            <>
                                                                <div className="form-group col-md-12 mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        <p className="mb-0 mr-4">Meaning</p>
                                                                        <div className="input-group w-75">
                                                                            <input type="text" className="form-control answertextBox"
                                                                                placeholder="Enter Meaning"
                                                                                value={item.meaning || ""}
                                                                                onChange={(e) =>
                                                                                    handleOnChangeOptions(
                                                                                        "meaning",
                                                                                        e.target.value,
                                                                                        idx
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {(item.sentences || []).map((sentence, idx1) => (
                                                                    <div className="form-group col-md-12 mb-2" key={idx1}>
                                                                        <div className="d-flex align-items-center">
                                                                            <p className="mb-0 mr-2">Sentence {idx1 + 1}</p>
                                                                            <div className="input-group w-75">
                                                                                <input type="text" className="form-control answertextBox"
                                                                                    placeholder="Enter Sentence"
                                                                                    value={sentence || ""}
                                                                                    onChange={(e) =>
                                                                                        handleOnChangeOptions(
                                                                                            "sentences",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        let newData = [...data];
                                                                                        newData[idx].sentences.splice(idx1, 1);
                                                                                        setData(newData);
                                                                                    }}
                                                                                >
                                                                                    <i className="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.optionsError && (
                                                                    <p className="text-danger">
                                                                        {item.optionsErrorMessages[0]}
                                                                    </p>
                                                                )}
                                                                <button type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        let newData = [...data];
                                                                        newData[idx].sentences = [...(newData[idx].sentences || []), ""];
                                                                        setData(newData);
                                                                    }}>
                                                                    <i className="mdi mdi-plus-circle"></i> Add Sentence
                                                                </button>
                                                            </>
                                                        )}
                                                        {/* Video learning section (optional) */}
                                                        {qtype === "learning" && item.includeVideo && (
                                                            <>
                                                                <hr className="my-3" />
                                                                <h6 className="mb-2">Video Learning</h6>
                                                                <div className="form-group col-md-12 mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        <p className="mb-0 mr-4">YouTube URL</p>
                                                                        <div className="input-group w-75">
                                                                            <input type="text" className="form-control answertextBox"
                                                                                placeholder="Enter YouTube URL"
                                                                                name="videoUrl"
                                                                                value={item.videoUrl || ""}
                                                                                onChange={(e) => handleChange(e, idx)}
                                                                            />
                                                                            <button
                                                                                className="btn btn-outline-primary"
                                                                                type="button"
                                                                                onClick={() => handleFetchVideoDetails(idx)}
                                                                            >Fetch</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {item.metaData && (
                                                                    <VideoCard videoDetails={item.metaData} />
                                                                )}
                                                                <div className="answer_header">
                                                                <p className="question-no">Questions</p>
                                                                <p></p>
                                                                </div>
                                                                {item?.subQuestions?.map((subQuestion, idx1) => (
                                                                    <div className="form-group col-md-12" key={idx1}>
                                                                        <p className="answers_title">Question {idx1+1}</p>
                                                                        <div className="input-group">
                                                                            <div className="d-flex align-items-center col-md-12 mb-2">
                                                                                <div className="col-md-10 col-sm-5">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control subq"
                                                                                        placeholder="Enter Question"
                                                                                        value={subQuestion.question}
                                                                                        onChange={(e) => handleOnChangesubQuestions("question", e.target.value, idx, idx1)}
                                                                                    />
                                                                                </div>
                                                                                <button type="button"
                                                                                    className="btn btn-customprimary ms-2"
                                                                                    style={{ opacity: "50%" }}
                                                                                    onClick={(e) => handleOnAddOptionsForSubQuestions(e, idx, idx1)}>
                                                                                    <i className="mdi mdi-plus-circle"></i> Add Options
                                                                                </button>
                                                                                <button
                                                                                    disabled={item.subQuestions.length === 1}
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) => handleOnDeletesubQuestions(e, idx, idx1)}>
                                                                                    <i className="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                            <p className="answers_title">Options</p>
                                                                            {subQuestion.options?.map((option, idx2) => (
                                                                                <div className="col-12" key={idx2}>
                                                                                    <div className="row mb-2">
                                                                                        <div className="col-6">
                                                                                            <div className="input-group">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    name={`answer_${idx}${idx1}${idx2}`}
                                                                                                    className="form-control"
                                                                                                    placeholder="Enter Option"
                                                                                                    value={option.answer}
                                                                                                    onChange={(e) =>
                                                                                                        handleOnChangeOptionsForSubQuestions(
                                                                                                            "answer",
                                                                                                            e.target.value,
                                                                                                            idx,
                                                                                                            idx1,
                                                                                                            idx2
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                                <div className="input-group-append">
                                                                                                    <div className="input-group-text answerRadioBtn">
                                                                                                        <div className="custom-control custom-radio">
                                                                                                            <input type="radio"
                                                                                                                name={`is_correct${idx}${idx1}${idx2}`}
                                                                                                                className="custom-control-input"
                                                                                                                checked={option.is_correct}
                                                                                                                onChange={(e) =>
                                                                                                                    handleOnChangeOptionsForSubQuestions(
                                                                                                                        "is_correct",
                                                                                                                        true,
                                                                                                                        idx,
                                                                                                                        idx1,
                                                                                                                        idx2
                                                                                                                    )
                                                                                                                } />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <button
                                                                                                    className="btn deleteAnswerBtn"
                                                                                                    onClick={(e) =>
                                                                                                        handleOnDeleteOptionsForSubQuestions(e, idx, idx1, idx2 )
                                                                                                    }
                                                                                                >
                                                                                                    <i className="uil-times"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                            {subQuestion.optionsError && (
                                                                                <p className="text-danger">
                                                                                    {item.optionsErrorMessages[0]}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {item.sub_questionsError && (
                                                                <p className="text-danger">
                                                                    {item.subQuestionsErrorMessages[0]}
                                                                </p>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-customprimary"
                                                                    style={{ opacity: "50%" }}
                                                                    onClick={(e) => handleOnAddSubQuestions(e, idx, qtype)}
                                                                >
                                                                    <i className="mdi mdi-plus-circle"></i> Add Questions
                                                                </button>
                                                            </>
                                                        )}
                                                        {idx !== 0 ?
                                                            <button type="button"
                                                                className="btn btn-outline-primary delete-question-btn"
                                                                onClick={(e) => handleOnDeleteQuestion(e, idx)}>
                                                                Delete Question</button> : ''}
                                                    </>
                                                }
                                            </div>
                                        ))}

                                        {/* end row */}
                                    </div> {/* end card-body */}
                                </div> {/* end card*/}
                                <div className="d-flex">
                                    <button type="button" class="btn btn-primary mr-2" onClick={(e) => handleOnAddQuestion(e, qtype)}><i className="mdi mdi-plus-circle"></i>{qtype === 'reading' ? 'Add New Paragraph' : 'Add New Question'} </button>
                                    <button type="submit" class="btn btn-customprimary" onClick={() => handleSubmit()}>Submit Questions</button>
                                </div>

                            </div> {/* end col*/}
                        </div>
                        {/* end row*/}
                    </div>
                    {/* End of Main Content */}
                    <Footer />
                </div>
                {/* End of Content Wrapper */}
            </div>
        </div>
    )
};


export default AddElpQuestions;
